/**
 * The strings and the glyph each kind of anchor reads. The form places a piece
 * on the page, on a passage or on a point, so the fourth kind arrives on
 * pieces a figure placed and has to read as what it is: a piece
 * pinned to an image must never be described as
 * sitting on the page.
 *
 * `awaiting` is what the page is being asked for while the anchor is pending,
 * which the form's block and the reader's capture hint both say, so a kind the
 * page answers for reads the same sentence wherever it is shown.
 */
export const ANCHOR_KINDS = {
    page: { kind: 'anchorKindPage', anchored: 'anchoredToPage', icon: 'baseline-page-24px' },
    text: {
        kind: 'anchorKindText',
        anchored: 'anchoredToText',
        awaiting: 'anchorAwaitingText',
        recapture: 'changePassage',
        icon: 'quote-24px',
    },
    point: {
        kind: 'anchorKindPoint',
        anchored: 'anchoredToPoint',
        awaiting: 'placeHere',
        recapture: 'movePoint',
        icon: 'note-marker',
    },
    image: { kind: 'anchorKindImage', anchored: 'anchoredToImage' },
};

/** The kinds the operator chooses between, in the order the strip draws them: the ones with a glyph to draw. */
export const OFFERED_ANCHOR_KINDS = Object.keys(ANCHOR_KINDS).filter(kind => ANCHOR_KINDS[kind].icon);

/** The kinds the operator points at on the page, which is what having something to await means. */
export const CAPTURED_ANCHOR_KINDS = Object.keys(ANCHOR_KINDS).filter(kind => ANCHOR_KINDS[kind].awaiting);

/**
 * What a kind reads, or nothing for one this map does not name. The map is a
 * plain object and the kind is a free string, so a kind named after something
 * every object carries would otherwise answer with a function.
 *
 * @param {string|null|undefined} type - An anchor's `type`
 * @returns {object|null}
 */
export function anchorKindKeys(type) {
    return Object.prototype.hasOwnProperty.call(ANCHOR_KINDS, type) ? ANCHOR_KINDS[type] : null;
}
